<a
  class="main__left"
  [routerLink]="
    pagebuilderMode
      ? []
      : mediaData?.kind === 'GALLERY'
      ? ['/ga/', mediaData?.id]
      : ['/g/', mediaData?.id]
  "
>
  <app-single-image
    *ngIf="mediaData !== null"
    class="image"
    [imageLoadingPreviewUrl]="mediaData!.preview![0].preview_url_blur!"
    [imagePreviewUrl]="calculateUrl(mediaData!.preview![0].preview_url_large!)"
  >
  </app-single-image>
  <app-single-image
    *ngIf="mediaData === null"
    class="image"
    [imageLoadingPreviewUrl]="noImgSectionUrl"
    [imagePreviewUrl]="noImgSectionUrl"
  >
  </app-single-image>

  <div class="main__overlay">
    <div class="main__header">
      <div class="main__count-icon"></div>
      <div class="main__count">{{ mediaData?.count }}</div>
      <div class="main__vr"></div>
      <div class="main__date" *ngIf="mediaData?.timestamp !== null">
        {{ mediaData?.timestamp | date : "dd.MM.yyyy. HH:mm" }}
      </div>
      <div class="main__date" *ngIf="mediaData?.timestamp === null">
        {{ "01.01.1900. 00:00" }}
      </div>
    </div>
    <p class="main__text">
      {{
        (currentLanguage ? productTitle : productTitleEn) ||
          "Placeholder headline"
      }}
    </p>
  </div>
</a>
